module.exports = __webpack_public_path__ + "img/720.c8032490.svg";